import { Box, ColorOptions, Icon, ModalDialogNew, ModBox, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useState } from 'react'
import FiltersView from '../../comps/FiltersView/Filters'
import { TransasctionApiType } from '../../data/models/Transaction'
import { useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { Colors, logEvent } from '../../util/util'
import { AppliedFilters } from './AppliedFilters'

export const SearchBarWithFilters = ({ onApply, filterList, filtersData, index, clearLoadMoreError }: any) => {
  const navigation = useNavigation()
  const {
    resetPaginationTxn,
    updateReceivedFilters,
    updateRefundFilters,
    updateReceivedMin,
    updateRefundMin,
    updateReceivedMax,
    updateRefundMax,
    updateReceivedSelectedDateInfo,
    updateRefundSelectedDateInfo,
    updateReceivedFilterSelectedDateInfo,
    updateRefundFilterSelectedDateInfo,
    resetTxnHistory,
  } = useStores((store) => ({
    resetPaginationTxn: store.transactions.resetPaginationNative,
    updateReceivedFilters: store.transactions.receivedFilter.updateFilters,
    updateRefundFilters: store.transactions.refundFilter.updateFilters,
    updateReceivedSelectedDateInfo: store.transactions.updateReceivedSelectedDateInfo,
    updateRefundSelectedDateInfo: store.transactions.updateRefundedSelectedDateInfo,
    updateReceivedFilterSelectedDateInfo: store.transactions.receivedFilter.updateSelectedDateInfo,
    updateRefundFilterSelectedDateInfo: store.transactions.refundFilter.updateSelectedDateInfo,
    updateReceivedMin: store.transactions.receivedFilter.updateMin,
    updateRefundMin: store.transactions.refundFilter.updateMin,
    updateReceivedMax: store.transactions.receivedFilter.updateMax,
    updateRefundMax: store.transactions.refundFilter.updateMax,
    resetTxnHistory: store.transactions.resetTxnHistory,
  }))
  const [filtersVisible, setFiltersVisible] = useState(false)

  // console.log('test filtersData', index, filtersData ? JSON.parse(JSON.stringify(filtersData)) : filtersData)
  // console.log('test filterList', index, filterList ? JSON.parse(JSON.stringify(filterList)) : filterList)

  const handleAppy = () => {
    logEvent('btn_press', 'apply_filters')
    setFiltersVisible(false)
    resetPaginationTxn()
    onApply()
  }

  const handleClearAll = () => {
    logEvent('btn_press', 'clear_filters')
    clearLoadMoreError?.() // TODO: reset filters from parent component
    onApply()
  }
  const appliedFilters = filterList?.filter((item) => {
    return item.value?.toUpperCase() !== 'ALL'
  })

  return (
    <>
      <Box ph={24} justify="space-between" bg="WHITE" align={'center'} gap={5} flexDirection={'row'} pv={10} pt={20}>
        <ModBox
          borderColor={Colors.GREY_BG as ColorOptions}
          borderWidth={1}
          borderRadius={8}
          flexDirection={'row'}
          align={'center'}
          gap={8}
          pl={16}
          h={40}
          f={1}
          underlayColor={'TRANSPARENT'}
          testID="search-txn"
          onPress={() => [
            resetTxnHistory(),
            logEvent('btn_press', 'open_search_payments'),
            navigation?.navigate(
              Routes.SEARCH as never,
              { type: index === 0 ? TransasctionApiType.transaction : TransasctionApiType.refunds } as never,
            ),
          ]}>
          <Icon id={'SEARCH'} color={Colors.GREY_BG as ColorOptions} size={16} />
          <Text
            fontFamily="JioType-Medium"
            fontSize={14}
            title="Search Transactions"
            color={Colors.GREY_BG as ColorOptions}
          />
        </ModBox>
        <Box
          flexDirection={'row'}
          align={'center'}
          gap={8}
          underlayColor={'TRANSPARENT'}
          testID="show-filter"
          onPress={() => [logEvent('btn_press', 'open_payments_filter'), setFiltersVisible(true)]}>
          <Box>
            <Icon id={'FILTER2'} color={Colors.BLACK_14 as ColorOptions} size={16} />
          </Box>
          <Text
            fontFamily="JioType-Medium"
            fontSize={14}
            title="Filters"
            lineHeight={16}
            letterSpacing={-0.06}
            color={Colors.BLACK_14 as ColorOptions}
          />
        </Box>

        <ModalDialogNew show={filtersVisible} animate={true} type="bottom" backgroundColor="TRANSPARENT">
          <Box bg={'WHITE'} borderTopLeftRadius={24} borderTopRightRadius={24}>
            <FiltersView
              filterVisible={filtersVisible}
              setFilterVisible={setFiltersVisible}
              applyFilters={handleAppy}
              clearFilters={handleClearAll}
              updateSelectedDateInfo={
                index === 0 ? updateReceivedFilterSelectedDateInfo : updateRefundFilterSelectedDateInfo
              }
              filtersList={filterList}
              index={index}
            />
          </Box>
        </ModalDialogNew>
      </Box>
      <ModBox show={appliedFilters?.length} pb={10} bg={'WHITE'}>
        <AppliedFilters
          updateFilters={index === 0 ? updateReceivedFilters : updateRefundFilters}
          apply={handleAppy}
          updateMax={index === 0 ? updateReceivedMax : updateRefundMax}
          updateMin={index === 0 ? updateReceivedMin : updateRefundMin}
          updateSelectedDateInfo={index === 0 ? updateReceivedSelectedDateInfo : updateRefundSelectedDateInfo}
          updateSelectedFilterDateInfo={
            index === 0 ? updateReceivedFilterSelectedDateInfo : updateRefundFilterSelectedDateInfo
          }
          filterList={appliedFilters}
        />
      </ModBox>
    </>
  )
}
